type PricingObject = {
  id: string;
  transactionCost: number;
  cardNotPresentTransactionCost: number;
  rate: number;
  cardNotPresentRate: number;
  isDefault: boolean;
  createdAt: string;
};

export type PricingDetailsInput = {
  rate: number;
  transactionCost: number;
};

export type PricingModel = {
  pricingId: string;
  cardNotPresent: PricingDetailsInput;
  cardPresent: PricingDetailsInput;
  mobileTapToPay: PricingDetailsInput;
  ach: PricingDetailsInput;
  surcharge?: PricingDetailsInput;
  createdAt: string;
  locationId: string;
  plan: { name: MerchantPlanTypes };
  userId: string;
  surchargeMonetizationStrategy: string;
};

export type EditPricingModel = Pick<
  PricingModel,
  | 'plan'
  | 'cardPresent'
  | 'cardNotPresent'
  | 'mobileTapToPay'
  | 'ach'
  | 'surcharge'
  | 'surchargeMonetizationStrategy'
>;

// The pricing response was merged with a pricing object for backwards compatibility.
// Going forward with split tear pricing, we will use the pricings array. The top level
// pricing object will be the latest price.
export type OldPricingModel = PricingObject & {
  pricings: PricingObject[];
};

export enum MerchantPlanTypes {
  TextToPay = 'TextToPay',
  Full = 'Full',
  CardNotPresent = 'CardNotPresent',
  MobileTapToPay = 'MobileTapToPay',
}
export enum MerchantPlanTypeLabels {
  TextToPay = 'Text to Pay',
  Full = 'Full Payments',
  CardNotPresent = 'Card Not Present',
  MobileTapToPay = 'Mobile Tap to Pay',
}
export enum CreateNewPricingMerchantPlanTypes {
  TextToPay = 'TEXT_TO_PAY',
  Full = 'FULL',
  CardNotPresent = 'CARD_NOT_PRESENT',
  MobileTapToPay = 'MOBILE_TAP_TO_PAY',
}

export type CreateNewPricingModel = {
  pricingId?: string;
  cardNotPresent: PricingDetailsInput;
  cardPresent?: PricingDetailsInput;
  mobileTapToPay?: PricingDetailsInput;
  surcharge?: PricingDetailsInput;
  surchargeMonetizationStrategy?: string;
  ach?: PricingDetailsInput;
  planName: CreateNewPricingMerchantPlanTypes;
  locationId: string;
};
